export function PageLoadingShimmer({ overlay = false }) {
  return (
    <div
      className={`page-loading${overlay ? " page-loading--overlay" : ""}`}
      role='status'
      aria-live='polite'
      aria-label='Loading page content'
    >
      <div className='page-loading__inner'>
        <div className='page-loading__logo' aria-hidden='true' />
        <div className='page-loading__track'>
          <div className='page-loading__track-fill' />
        </div>
        <p className='page-loading__text'>Loading</p>
      </div>
    </div>
  );
}
